import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Spin } from "antd";
import { Loading3QuartersOutlined, LockFilled, UserOutlined } from "@ant-design/icons";
import ForgetCodeModal from "../../components/loginPage/ForgetCodeModal";
import { login } from "../../service/api";
import {  useMutation, useQueryClient } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";

function LoginForm() {

  const [openModal, setOpenModal] = useState(false);
  const [loginModel, setLoginModel] = useState({});
  const navigate = useNavigate();
  const antIcon = (<Loading3QuartersOutlined style={{ fontSize: 24, color: 'white' }} spin />);
  const queryClinet = useQueryClient()
  const modalHandler = () => {
    if (openModal === false) {
      setOpenModal(true);
    } else if (openModal === true) {
      setOpenModal(false);
    }

  };


  const mutation = useMutation(login, {
    onSuccess: data => {
      localStorage.setItem(['profile'], JSON.stringify(data))
      queryClinet.invalidateQueries(['statistics'])
      navigate('/')
    }
  });

  const setMyLoginModel = (e) => {
    setLoginModel({ ...loginModel, [e.target.name]: e.target.value });
  };

  return (
    <>

      <Form
        name="normal_login"
        className=" flex-col w-[35vw] max-lg:w-full items-center justify-start bg-[rgba(255,255,255,0.5)] p-[50px] max-lg:px-[2rem] max-lg:py-[3rem] border-r[15px] rounded-[15px] shadow-lg font-body "
        initialValues={{ remember: true }}
      >
        {openModal &&
          <ForgetCodeModal setOpenModal={setOpenModal} visible={openModal} closeHandler={modalHandler} />
        }

        <section className="gap-[10px] flex flex-col items-center pb-12 max-lg:pb-5  ">
          <h2 className=" text-[21px] max-lg:text-sm font-bold text-[#4D4D4D] max-lg:text-[1rem] ">
            وارد حساب کاربری خود شوید
          </h2>
          <hr className=" border-gray-300 w-3/4 " />
        </section>

        <Form.Item
          className="pb-8 max-lg:pb-2"
          name="username"
          rules={[
            { required: true, message: "لطفا کد کارشناسی خود را وارد کنید" },
          ]}
        >
          <Input
            className="text-[1rem] max-lg:text-[0.75rem] p-3"
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="کد کارشناس"
            name="expertCode"
            onChange={setMyLoginModel}
          />
        </Form.Item>

        <Form.Item
          labelAlign=""
          name="password"
          className="pb-4 max-lg:pb-0"
          rules={[{ required: true, message: "لطفا رمز عبور خود را وارد کنید" }]}
        >
          <Input.Password
            className="text-[1rem] max-lg:text-[0.75rem] p-3"
            prefix={<LockFilled className="site-form-item-icon" />}
            type="password"
            placeholder="رمز عبور"
            name="password"
            onChange={setMyLoginModel}
          />
        </Form.Item>

        <Form.Item>
          <Checkbox className="font-semibold font-body text-[0.75rem] text-[#4D4D4D]">
            مرا به خاطر بسپار
          </Checkbox>
        </Form.Item>
        <Form.Item className="pb-12 max-lg:pb-0">
          <button
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              mutation.mutate(loginModel);
            }}
            className="bg-gradient-to-r from-[#19385F] to-[#005AC7] text-white text-[24px] p-[4px] w-full rounded-[10px] max-lg:p-3 max-lg:text-sm"
          >
            {
              mutation?.isLoading ? <Spin indicator={antIcon} /> : 'ورود به داشبورد'
            }
          </button>
        </Form.Item>
        <section
          dir="rtl"
          className="flex flex-col w-full text-[12px] font-bold leading-[18px] px-12 max-lg:px-2 gap-[12px] justify-center text-[#0D6EFD]"
        >
          <div
            dir="rtl"
            className="flex flex-row items-center justify-between w-full gap-[12px] max-lg:gap-1"
          >
            <p dir="rtl">رمز عبور خود را فراموش کرده اید؟</p>
            <Button className="p-0 text-[#0D6EFD]" onClick={modalHandler} dir="rtl" type="button">
              بازیابی رمز عبور
            </Button>
          </div>
          <div
            dir="rtl"
            className="flex flex-row items-center justify-between w-full gap-[12px] "
          >
            <p dir="rtl">کارشناس اگرویار نیستید؟</p>
            <Link className="p-0 text-[#0D6EFD]" type="text" to="https://agroiranexpert.com/expert-register">ثبت نام کارشناس</Link>
          </div>
        </section>
      </Form>



    </>
  );
}

export default LoginForm;
